import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=10abd57c&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/components/NoteModal.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/components/NoteModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abd57c",
  null
  
)

export default component.exports